import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  Optional,
  Self,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgControl } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { SimpleField } from '../../abstracts/simple-field';
import { Moment } from 'moment/moment';

@Component({
  selector: 'fb-date-range-field',
  templateUrl: './date-range-field.component.html',
  styleUrls: ['./date-range-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeFieldComponent extends SimpleField<[string, string]> implements OnInit {
  @Input() min: number | string;
  @Input() max: number | string;
  @Input() maxDate: Date | Moment | string;
  @Input() formControl: FormControl;
  @Input() withNoResetDateRange: boolean;

  @ViewChild('picker') datePicker: MatDateRangePicker<unknown>;

  form: FormGroup;

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    public override ngControl: NgControl,
    private formBuilder: FormBuilder,
  ) {
    super(changeDetectorRef, ngControl);
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      startDate: [''],
      endDate: [''],
    });
    this.onWriteValue(this.ngControl.control.value);
    this.ngControl.control.valueChanges.subscribe(() => {
      if (!this.formControl.value) this.form.reset();
    });
    if (this.maxDate && moment.isMoment(this.maxDate)) {
      this.maxDate = new Date(moment(this.maxDate).startOf('day').toISOString());
    }
  }

  onClear(): void {
    this.form.reset();
    this.formControl.reset();
    this.onWriteValue(this.prepareData(this.form.value) || ['', '']);
  }

  protected override onWriteValue(data: [string, string]): void {
    if (this.form && Boolean(data)) {
      this.value = data;
      const [startDate, endDate]: [string, string] = data;
      this.form.patchValue({ startDate, endDate }, { emitEvent: false });
    }
  }

  private prepareData({ startDate, endDate }: { startDate: moment.Moment; endDate: moment.Moment }): [string, string] {
    const start: string = startDate ? moment(startDate).toDate().toISOString() : undefined;
    const end: string = endDate ? moment(endDate).toDate().toISOString() : undefined;
    return [start, end];
  }
}
